<script setup>
import { useGlobalStore } from '@stores/global'
import { useProductStore } from '@stores/product'
import { ref } from 'vue'

import Button from '@components/global/button.vue'
import ProductCard from '@components/global/product-card.vue'

const global = useGlobalStore()
// const selected = ref(global.newsCategory[0])

const productStore = useProductStore()
</script>
<template>
	<section class="container">
		<div class="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
			<ProductCard :item="product" v-for="product in productStore.products" :key="product.id" />
		</div>
	</section>
</template>
